import React from 'react';
import { connect } from 'react-redux';
import Loading from '../../Loading';
import s from './style.css';
const mapStateToProps = (state) => ({
    loading: state.progress.loading,
});
const connector = connect(mapStateToProps);
export const ButtonText = ({ icon, text }) => {
    return (React.createElement("div", { className: s.innerContainer },
        React.createElement("div", { style: { paddingRight: 8 } }, icon),
        React.createElement("p", { className: s.text }, text)));
};
const Button = ({ text, onClick, id, loading, style, colored, icon, loadingDisabled }) => {
    return (React.createElement("button", { className: `${s.button} ${colored ? s.colored : s.black}`, style: style, type: 'button', onClick: () => {
            if (!loading)
                onClick?.();
        }, id: id }, loading && !loadingDisabled ? React.createElement(Loading, { colored: colored }) : React.createElement(ButtonText, { icon: icon, text: text })));
};
export default connector(Button);
